import { Observable } from 'rxjs';
import {
  CreateLeadRequestModel,
  CreateLeadResponseModel, GetLeadResponseModel,
  UpdateLeadRequestModel,
  UpdateLeadResponseModel,
} from '../../models/lead.model';
import { LEAD } from '../../app.consts';
import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/local/environment';

const mapPhoneNumber = (phoneNumber: string): string => {
  if (
    phoneNumber.startsWith('0046') ||
    phoneNumber.startsWith('00358') ||
    phoneNumber.startsWith('0031')
  ) {
    return phoneNumber;
  } else if (
    phoneNumber.startsWith('46') ||
    phoneNumber.startsWith('358') ||
    phoneNumber.startsWith('31')
  ) {
    return `00${phoneNumber}`;
  } else {
    return `${environment.countryPrefix}${
      phoneNumber.startsWith('0') ? phoneNumber.slice(1) : phoneNumber
    }`;
  }
};

@Injectable()
export class LeadApiService extends BaseApiService {
  constructor(private http: HttpClient, protected auth: AuthService) {
    super(auth);
  }

  createLead(
    lead: CreateLeadRequestModel
  ): Observable<CreateLeadResponseModel> {
    const parsedLead = lead.phoneNumber
      ? { ...lead, phoneNumber: mapPhoneNumber(lead.phoneNumber) }
      : lead;
    return this.http.post<CreateLeadResponseModel>(
      `${this.apiUrl}${LEAD}`,
      parsedLead
    );
  }

  updateLead(
    lead: UpdateLeadRequestModel
  ): Observable<UpdateLeadResponseModel> {
    const parsedLead = {
      ...lead,
      phoneNumber: lead.phoneNumber && mapPhoneNumber(lead.phoneNumber),
    };
    return this.http.put<UpdateLeadResponseModel>(
      `${this.apiUrl}${LEAD}/${lead.id}`,
      parsedLead
    );
  }

  getLead(leadId: string): Observable<GetLeadResponseModel> {
    return this.http.get<GetLeadResponseModel>(
      `${this.apiUrl}${LEAD}/${leadId}`
    );
  }

  tmLeadNotify(leadId: string): Observable<any> {
    return this.http.post(`${this.apiUrl}${LEAD}/${leadId}/notify`, {});
  }
}
